<template>
    <ValidationObserver ref="observer">
        <section class="mt-3 mb-3 mb-lg-4" id="paso-6">
            <div class="container">
                <div class="row">
                    <div class="col-12 p-0">
                        <div class="mb-4 h3 text-uppercase">{{ $t('bases.resumen_compra') }}</div>
                        <div class="pt-1 mx-auto bg-light">
                            <ResumenCompraComponent
                                class="m-3"
                                :categoria="localData.categoria_base"
                                :esMovil="esMovil"
                                :loading="loading"
                                @isAccepted="conditions_accepted_handler"
                            />
                        </div>
                        <div v-if="are_conditions_accepted">
                            <div v-if="formulario" id="formulario-compra" v-html="formulario"></div>
                            <div v-if="show" class="col-12 text-right mt-4">
                                <div class="text-right mt-3">
                                    <button type="button" @click="$emit('volver')" name="button" :class="!esMovil ? 'button effect-button large-button mr-2' : 'button effect-button mr-2'" id="volver-paso-5" :disabled="loading" >
                                        <span>{{ $t('formularios.atras') }}</span>
                                    </button>
                                    <button @click="cargarFormularioPago()" name="button" :class="!esMovil ? 'button effect-button large-button' : 'button effect-button'" id="terminar-paso-6" :disabled="!show || loading">
                                        <span>{{ $t('bases.terminar') }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <b-card v-else bg-variant="info" style="margin: 20px">
                            <b-card-text>
                                {{ $t('bases.condiciones') }}
                            </b-card-text>
                        </b-card>
                    </div>
                </div>
            </div>
        </section>
    </ValidationObserver>
</template>

<script>
    import ResumenCompraComponent from "@/components/frontend/bases/ResumenCompraComponent";

    export default {
        props: ["base", "esMovil"],
        data() {
            return {
                formulario: null,
                are_conditions_accepted: false,
                localData: { ...this.base },
                show: true,
                loading: false
            };
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            }
        },
        methods: {
            conditions_accepted_handler(value) {
                this.are_conditions_accepted = value;
            },
            cargarFormularioPago() {
                this.loading = true;

                const params = {
                    filters: {},
                    session_id: this.localData.categoria_base.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bases.get-formulario-pago'), params).then(res => {
                    if (res.data.formulario) {
                        this.formulario = res.data.formulario;
                    } else {
                        this.localData.jet_id = res.data.tpv_jet_id;
                        this.$emit('terminado', this.localData);
                    }
                    this.show = false;
                }).finally(() => {
                    this.loading = false;
                });
            }
        },
        components: {
            ResumenCompraComponent
        },
    };
</script>
